import { chakra, Flex, Text } from "@chakra-ui/react";
import React, { PropsWithChildren } from "react";

interface WithTitleSubPanelProps extends PropsWithChildren {
  title?: string;
  desc?: string;
  className?: string;
}

const SubpanelWithTitle: React.FC<WithTitleSubPanelProps> = (props) => {
  const { title, desc, children, className } = props;
  return (
    <Flex flexDir="column" pt="16px" px="16px" color="white" className={className}>
      <Text fontSize="22px" fontWeight={600}>
        {title}
      </Text>
      <Text color="#e5e5e5">{desc}</Text>
      {children}
    </Flex>
  );
};
export const SubWithTitle = chakra(SubpanelWithTitle);
